import type { UseFetchOptions } from 'nuxt/app'
import type { StrapiEventListPage } from '~/composables/types/strapiEventListPage'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'

export function useStrapiArticlesCategory({
  slug,
  options = {},
  locale,
}: {
  slug?: string
  options?: UseFetchOptions<
    StrapiApiDefaultResponse<StrapiEventListPage[]>,
    StrapiEventListPage[]
  >
  locale?: string
} = {}) {
  const localeDefault = useI18n().locale
  const articlesCategoryUrl = getStrapiArticlesCategoryUrl(
    slug ?? '',
    locale ?? localeDefault.value
  )

  return useStrapi<StrapiEventListPage>({
    urlSuffix: articlesCategoryUrl,
    options,
    lazy: true,
  })
}
